import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import QaiScorecardChallengeQuestionsViewModel from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface ITablePageControlProps {
    challengedQuestionsViewModel: QaiScorecardChallengeQuestionsViewModel
    pageNumber: number
    changePage: (pageNumber: number) => void
}

export default function TablePageControl({ challengedQuestionsViewModel, changePage, pageNumber }: ITablePageControlProps) {
    return (
        <Grid container size={12} spacing={1} paddingTop={1}>
            <Grid>
                <Button
                    variant='contained'
                    onClick={() => changePage(pageNumber - 1)}
                    disabled={pageNumber === 0}>
                    Previous Page
                </Button>
            </Grid>
            <Grid>
                <Button
                    variant='contained'
                    onClick={() => changePage(pageNumber + 1)}
                    disabled={(pageNumber + 1) === challengedQuestionsViewModel.pageCount}>
                    Next Page
                </Button>
            </Grid>
            <Grid>
                <TextField
                    value={pageNumber + 1}
                    margin="none"
                    size="small"
                    style={{ width: '75px', marginLeft: '8px', marginRight: '8px' }}
                />
            </Grid>
            <Grid>
                <Typography paddingTop='15px'>of {challengedQuestionsViewModel.pageCount === 0 ? 1 : challengedQuestionsViewModel.pageCount}</Typography>
            </Grid>
        </Grid>
    )
}